import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-buttons" }
const _hoisted_2 = ["disabled"]

import { PropType, reactive, watch, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { Actions, BazaarState } from '@/models/store.model';
import {
  Content,
  ContentInput,
  contentValidation,
} from '@/models/content.model';
import Button from '@/components/common/Button.vue';
import Field from '@/components/common/Field.vue';
import FieldFile from '@/components/common/FieldFile.vue';
import { useLoading } from '../common/loading.composable';
import { MdEditor } from 'md-editor-v3';
import 'md-editor-v3/lib/style.css';
import { DrawerActions } from '@/core/drawer.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentForm',
  props: {
  data: { type: Object as PropType<{ id: number }> },
},
  setup(__props) {

const store = useStore<BazaarState>();

const props = __props;

const content = reactive<ContentInput>({
  id: -1,
  title: '',
  content: '',
  image: undefined,
});

const item = computed<Content | null>(() => store.state.contentItem);

watch(item, (newValue) => {
  if (newValue) {
    Object.assign(content, newValue);
  }
});

onMounted(() => {
  if (props.data?.id) {
    store.dispatch(Actions.GetContentItem, props.data.id);
  }
});

const rules = contentValidation;
const $v = useVuelidate(rules, content);
const { loading, setLoading } = useLoading();
const addContent = async () => {
  $v.value.$touch();

  if (!$v.value.$invalid) {
    const data = new FormData();
    if (content.image && typeof content.image !== 'string') {
      data.append('content', JSON.stringify({ ...content, image: undefined }));
      data.append('file', content.image);
    } else {
      data.append('content', JSON.stringify({ ...content }));
    }

    setLoading(true);
    if (content.id === -1) {
      await store.dispatch(Actions.AddContent, data);
    } else {
      await store.dispatch(Actions.UpdateContent, data);
    }
    setLoading(true);
    store.dispatch(DrawerActions.CloseDrawer);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(addContent, ["prevent"])
  }, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Content block toevoegen", -1)),
    _createVNode(Field, {
      label: "Titel",
      modelValue: content.title,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content.title) = $event)),
      validation: _unref($v).title
    }, null, 8, ["modelValue", "validation"]),
    _createVNode(_unref(MdEditor), {
      label: "Text",
      modelValue: content.content,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((content.content) = $event)),
      language: "en-US",
      toolbars: ['bold', 'italic', 'underline', 'link', 'title']
    }, null, 8, ["modelValue"]),
    _createVNode(FieldFile, {
      label: "Plaatje",
      modelValue: content.image,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((content.image) = $event)),
      validation: _unref($v).image
    }, null, 8, ["modelValue", "validation"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        disabled: _unref(loading) || _unref($v).$invalid,
        class: "confirm",
        type: "submit"
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("span", { class: "text" }, "Opslaan", -1)
      ]), 8, _hoisted_2)
    ])
  ], 32))
}
}

})